import { Link } from 'react-router-dom';

const serviceLinks = [
  { label: 'Airport Transportation', href: '/services/airport-transportation' },
  { label: 'Wedding Transportation', href: '/services/wedding-transportation' },
  { label: 'Corporate Transportation', href: '/services/corporate-transportation' },
  { label: 'Event Transportation', href: '#contact' },
  { label: 'Prom Transportation', href: '#contact' },
  { label: 'Private Chauffeur', href: '#contact' },
  { label: 'Charleston Sights Tours', href: '#contact' },
  { label: 'Cruises & Port Transport', href: '#contact' },
];

const locationLinks = [
  { label: 'Charleston, SC', href: '/location/charleston-sc' },
  { label: 'Mount Pleasant, SC', href: '/location/charleston-sc' },
  { label: 'North Charleston, SC', href: '/location/charleston-sc' },
  { label: 'Summerville, SC', href: '/location/charleston-sc' },
  { label: 'Isle of Palms, SC', href: '/location/charleston-sc' },
  { label: 'Kiawah Island, SC', href: '/location/charleston-sc' },
];

export default function SiteFooter() {
  return (
    <footer style={{ backgroundColor: '#0f0a05' }}>
      <div className="h-0.5 bg-gradient-to-r from-transparent via-gold to-transparent"></div>

      <div className="max-w-7xl mx-auto px-6 pt-16 pb-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-5 cursor-pointer">
              <span className="text-gold font-display text-3xl font-bold tracking-widest uppercase block">TECS</span>
              <span className="text-white/45 text-[10px] tracking-[0.25em] uppercase font-light">Limo Service LLC</span>
            </Link>
            <p className="text-white/35 text-xs leading-relaxed mb-5">
              Professional luxury transportation for airport transfers, corporate travel, weddings, and special events. Serving Charleston, SC and surrounding areas — available 24/7.
            </p>
            <div className="flex items-center gap-1 mb-5">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-star-fill text-gold text-xs"></i>
                </div>
              ))}
              <span className="text-white/35 text-xs ml-1">5-Star Rated</span>
            </div>
            <a
              href="https://goo.gl/maps/jrKSzYSzTT1bAbWc7"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-1.5 text-gold text-xs hover:text-gold-light transition-colors cursor-pointer"
            >
              <div className="w-3 h-3 flex items-center justify-center"><i className="ri-external-link-line text-xs"></i></div>
              Leave a Google Review
            </a>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-xs tracking-widest uppercase mb-5 pb-2 border-b border-gold/20">Our Services</h4>
            <ul className="space-y-2.5">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  {link.href.startsWith('/') ? (
                    <Link to={link.href} className="flex items-center gap-2 text-white/40 hover:text-gold transition-colors text-xs tracking-wide cursor-pointer group">
                      <div className="w-3 h-3 flex items-center justify-center flex-shrink-0"><i className="ri-arrow-right-s-line text-gold/40 group-hover:text-gold text-xs transition-colors"></i></div>
                      {link.label}
                    </Link>
                  ) : (
                    <a href={link.href} className="flex items-center gap-2 text-white/40 hover:text-gold transition-colors text-xs tracking-wide cursor-pointer group">
                      <div className="w-3 h-3 flex items-center justify-center flex-shrink-0"><i className="ri-arrow-right-s-line text-gold/40 group-hover:text-gold text-xs transition-colors"></i></div>
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Locations */}
          <div>
            <h4 className="text-white font-semibold text-xs tracking-widest uppercase mb-5 pb-2 border-b border-gold/20">Service Areas</h4>
            <ul className="space-y-2.5">
              {locationLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="flex items-center gap-2 text-white/40 hover:text-gold transition-colors text-xs tracking-wide cursor-pointer group">
                    <div className="w-3 h-3 flex items-center justify-center flex-shrink-0"><i className="ri-map-pin-2-line text-gold/40 group-hover:text-gold text-xs transition-colors"></i></div>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <h4 className="text-white font-semibold text-xs tracking-widest uppercase mb-5 pb-2 border-b border-gold/20">Quick Links</h4>
              <ul className="space-y-2.5">
                {[
                  { label: 'Home', href: '/', isLink: true },
                  { label: 'About Us', href: '/about', isLink: true },
                  { label: 'Book a Ride', href: '#contact', isLink: false },
                ].map((l) => (
                  <li key={l.label}>
                    {l.isLink ? (
                      <Link to={l.href} className="flex items-center gap-2 text-white/40 hover:text-gold transition-colors text-xs tracking-wide cursor-pointer group">
                        <div className="w-3 h-3 flex items-center justify-center flex-shrink-0"><i className="ri-arrow-right-s-line text-gold/40 group-hover:text-gold text-xs transition-colors"></i></div>
                        {l.label}
                      </Link>
                    ) : (
                      <a href={l.href} className="flex items-center gap-2 text-white/40 hover:text-gold transition-colors text-xs tracking-wide cursor-pointer group">
                        <div className="w-3 h-3 flex items-center justify-center flex-shrink-0"><i className="ri-arrow-right-s-line text-gold/40 group-hover:text-gold text-xs transition-colors"></i></div>
                        {l.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-xs tracking-widest uppercase mb-5 pb-2 border-b border-gold/20">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a href="tel:+18436422440" className="flex items-center gap-3 cursor-pointer group">
                  <div className="w-8 h-8 bg-gold/15 group-hover:bg-gold flex items-center justify-center flex-shrink-0 transition-colors">
                    <i className="ri-phone-fill text-gold group-hover:text-black text-sm transition-colors"></i>
                  </div>
                  <div>
                    <div className="text-white/30 text-xs mb-0.5">Primary — Book Now</div>
                    <div className="text-white group-hover:text-gold font-bold text-sm tracking-wide transition-colors">(843) 642-2440</div>
                  </div>
                </a>
              </li>
              <li>
                <a href="tel:+18435130018" className="flex items-center gap-3 cursor-pointer group">
                  <div className="w-8 h-8 bg-white/5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-white/35 text-sm"></i>
                  </div>
                  <span className="text-white/45 group-hover:text-gold text-sm transition-colors">(843) 513-0018</span>
                </a>
              </li>
              <li>
                <a href="mailto:tecslimoservice@gmail.com" className="flex items-center gap-3 cursor-pointer group">
                  <div className="w-8 h-8 bg-white/5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-white/35 text-sm"></i>
                  </div>
                  <span className="text-white/45 group-hover:text-gold text-xs break-all transition-colors">tecslimoservice@gmail.com</span>
                </a>
              </li>
              <li>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-gold/15 flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-fill text-gold text-sm"></i>
                  </div>
                  <div>
                    <div className="text-white/30 text-xs mb-0.5">Hours</div>
                    <div className="text-gold font-bold text-sm">Open 24/7</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Service areas strip */}
        <div className="border-t border-white/5 pt-6 mb-6">
          <p className="text-white/20 text-xs leading-relaxed text-center">
            <strong className="text-white/35">Serving:</strong> Awendaw · Bonneau · Charleston · Cottageville · Daniel Island · Dorchester · Edisto Beach · Folly Beach · Goose Creek · Hanahan · Hollywood · Isle of Palms · James Island · Kiawah Island · Ladson · Lincolnville · McClellanville · Moncks Corner · Mount Pleasant · North Charleston · Ravenel · Seabrook Island · St. George · Sullivan&apos;s Island · Summerville · Walterboro and more
          </p>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/5 pt-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/25 text-xs">&copy; 2026 TECS Limo Service LLC — All Rights Reserved.</p>
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 flex items-center justify-center"><i className="ri-map-pin-2-fill text-gold text-xs"></i></div>
            <span className="text-white/25 text-xs">Charleston SC · Berkeley County · Dorchester County</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
